import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=28f49cb8"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports